export const MessageBoxType = Object.freeze({
    INBOX: 'inbox',
    OUTBOX: 'outbox',
});
